/* eslint-disable no-empty-function */
import {Link} from "react-router-dom";
import PropTypes from "prop-types";
import React from "react";

export default class NavigationControls extends React.PureComponent {

  static propTypes = {
    "customer": PropTypes.object,
    "final": PropTypes.bool,
    "isDisabled": PropTypes.bool.isRequired,
    "nextRoute": PropTypes.string,
    "onAnswer": PropTypes.func.isRequired,
    "prevRoute": PropTypes.string,
    "skip": PropTypes.object
  };

  static defaultProps = {
    "customer": {
      "birthday": null,
      "entry_time": null,
      "id": null
    },
    "final": false,
    "isDisabled": false,
    "nextRoute": null,
    "prevRoute": null,
    "skip": null
  };

  handleBackClick = () => {
    scroll(0, 0);
    document.activeElement.blur();
  };

  handleForwardClick = () => {
    scroll(0, 0);
    document.activeElement.blur();


    const {"customer": {"entry_time": entryTime, id}, final} = this.props;
    if (final && id) {
      window.location = entryTime
        ? "/account?updated_survey=true"
        : "/signup/billing";
    }
  };

  handleSkipClick = () => {
    $("li.progress_step:not(.filled)").first().addClass("filled");
    scroll(0, 0);
    document.activeElement.blur();

    const {"skip": {surveyFields}, onAnswer} = this.props;
    onAnswer(surveyFields);
  };

  render () {
    const {final, isDisabled, nextRoute, prevRoute, skip} = this.props;

    return (
      <div>
        <div className="StyleSurveyNavigation pt24">
          {prevRoute &&
          <Link
            className="btn btn-secondary inline-block"
            onClick={this.handleBackClick}
            to={prevRoute}
          >
            Back
          </Link>}
          {nextRoute &&
          <Link
            className={`btn btn-primary inline-block ${prevRoute ? "" : "first-button"}
            ${isDisabled ? "disabled" : ""}`}
            onClick={isDisabled ? null : this.handleForwardClick}
            to={nextRoute}
          >
            {final
              ? "Finish"
              : "Next"}
          </Link>}
        </div>
        {nextRoute && skip && !final &&
        <Link
          className="inline-block mt32 skip-message footer-skip"
          onClick={this.handleSkipClick}
          to={nextRoute}
        >
          {skip.text}
        </Link>}
      </div>
    );
  }
}
